import { CONSTANTS } from '@/data';
import { logger } from '@/utils/logging';
import { RnSigmaDevice } from '@socure-inc/react-native-device-risk';

const LOG_TAG = '[SocureDeviceSession]';

let initialized = false;

export const getSocureDeviceSessionToken = async (): Promise<string | null> => {
    try {
        if (!initialized) {
            const { sessionToken } = await RnSigmaDevice.initializeSDK(CONSTANTS.SOCURE_DEVICE_RISK_SDK_KEY, {});
            initialized = true;
            return sessionToken || null;
        }
        const { sessionToken } = await RnSigmaDevice.getSessionToken();
        return sessionToken || null;
    } catch (error) {
        logger.warn(LOG_TAG, 'Failed to get session token — submitting KYC without it', error);
        return null;
    }
};
